import { DEFAULT_BRANDING_COMPANY_NAME } from '@config/config';
import { BRAND_COLORS, BRAND_STYLES } from '@constants/shared-colors';
import { CompanyBrandingData } from '@customTypes/CompanyBranding';

export const DEFAULT_BRANDING: CompanyBrandingData = {
  app_name: DEFAULT_BRANDING_COMPANY_NAME,
  primary_color: BRAND_COLORS.primary,
  secondary_color: BRAND_COLORS.secondary,
  accent_color: BRAND_COLORS.accent,
  font_family: BRAND_STYLES.fontFamily,
  theme_mode: 'light',
  primary_palette: {},
  secondary_palette: {},
  accent_palette: {},
  logo_url: '',
  additional_data: {
    body_bg: BRAND_COLORS.containerBg,
    sidebar_bg: BRAND_COLORS.sidebarBg,
    content_bg: BRAND_COLORS.contentBg,
    table_radius: BRAND_STYLES.tableRadius,
    color_table_row_hover: BRAND_COLORS.tableRowHover,
    color_body_text: BRAND_COLORS.bodyText,
    border_radius: BRAND_STYLES.borderRadius.default,
    border_radius_large: BRAND_STYLES.borderRadius.large,
    border_radius_medium: BRAND_STYLES.borderRadius.medium,
    border_radius_small: BRAND_STYLES.borderRadius.small,
  },
};
